export const LIST_REQUEST_PORTAL = "LIST_REQUEST_PORTAL";
export const SET_LIST_REQUEST_PORTAL = "SET_LIST_REQUEST_PORTAL";

export const SET_LOADING_LIST = "SET_LOADING_LIST";
export const COMMENT_TRIGGER = "COMMENT_TRIGGER";